@use "~theme/typographyV2" as typography;
@use "~theme/breakpoints";

.divider {
    display: none;
  
    @include breakpoints.desktop {
      @include typography.heading3;
      display: block;
      padding-bottom: 2px;
      margin: 0 0 9px;
      border: none;
      border-bottom: 2px solid var(--brand-indigo);
      width: 270px;
      max-width: 340px;
    }
  }

.headline {
    font-family: typography.$font-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 32px;
    line-height: 41px;
    letter-spacing: 0.3px;
    color: var(--Brand-Indigo, var(--brand-indigo));
    margin: 0;
    width: 340px;
    min-height: 41px;
    display: block;
}

.container {
    width: 67%; 
    padding-left: 20px;
    display: block;
    overflow: auto;
    float:left;
    background-color: var(--canvas-tan);
    margin-top: 10px;
}

.weekContainer{
    width: 100%;
    max-width: 100%;
    height: 90px;
    margin-top: 16px;
    margin-bottom: 18px;
    padding-right: 16px;
    display: flex;
    align-items: center;
    gap: 12px;
    box-sizing: border-box;
}

.daysViewport {
    flex: 1 1 auto;
    min-width: 0;
    width: 100%;
}

.daysRow {
    flex: 1 1 auto;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
}

.dayContainer {
    width: 100%;
    min-width: 0;
    max-width: 150px;
    height: 80px;
    /* White */
    background: var(--white);
    /* 03 Grey */
    border: 1px solid var(--gray-03);
    box-shadow: 0px 4px 8px 0px rgb(0 0 0 / 10%);
    border-radius: 20px;
    padding: 12px 20px;
    text-align: center;
    cursor:pointer;
    box-sizing: border-box;
    flex: 1 1 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 4px;
}

.daySelected {
    border: 1px solid var(--blue-02);
    border-radius: 20px;
    box-shadow: 0px 4px 8px 0px rgb(0 0 0 / 10%);
}
.dayWords {
    text-transform: uppercase;
    color: var(--blue-01);
    font-family: typography.$font-mont;
    font-weight: 700;
    font-style: normal;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 1.92px;
    text-align: center;
    vertical-align: middle;
    white-space: nowrap;

    @include breakpoints.desktop {
        font-weight: 600;
        font-style: normal;
        line-height: 130%;
        letter-spacing: 0px;
    }
}

.monthYear {
    font-weight: 400;
    color: var(--black);
    font-family: typography.$font-mont;
    font-style: normal;
    font-size: 16px;
    line-height: 15px;
    letter-spacing: 0.32px;
    text-align: center;
    vertical-align: middle;

    @include breakpoints.desktop {
        line-height: 130%;
        letter-spacing: 0px;
    }
}

.arrow {    
    flex: 0 0 auto;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    a {
        outline: none;
    }
    a:hover {
        border: none;
    }
    a:active {
        outline: none;
    }
    a:focus {
    outline: none;
    }
}

.arrowLeft {
    margin-right: 0;
}

.arrowRight {
    margin-left: 0;
}

.datePickerBand {
    display: contents;
}

.mobileDateScroller {
    box-sizing: border-box;
    display: flow-root;
    float: none;
    margin: 0;
    overflow: visible;
    padding: 0 20px;
    width: 100%;

    .datePickerBand {
        background: var(--white);
        box-sizing: border-box;
        display: block;
        margin-bottom: 20px;
        margin-left: -20px;
        margin-right: -20px;
        margin-top: 16px;
        padding: 10px 0 10px 10px;
        width: auto;
    }

    .headline {
        font-size: 28px;
        line-height: 27px;
        margin: 0;
        min-height: 27px;
        width: auto;
    }

    .daysRow {
        display: grid;
        gap: 8px;
        grid-template-columns: repeat(5, minmax(0, 1fr));
        max-width: 100%;
        min-width: 0;
        overflow: visible;
        width: 100%;
    }

    .daysViewport {
        contain: inline-size;
        overflow-x: clip;
    }

    .dayContainer {
        border-radius: 8px;
        box-shadow: 0 2px 6px rgb(0 0 0 / 10%);
        flex: none;
        gap: 0;
        height: 52px;
        max-width: none;
        padding: 2px;
        width: 100%;
    }

    .daySelected {
        border-radius: 8px;
    }

    .dayWords {
        font-size: 16px;
        letter-spacing: 1.92px;
        line-height: 24px;
    }

    .monthYear {
        color: var(--datepicker-gray);
        font-size: 14px;
        letter-spacing: 0.32px;
        line-height: 19.6px;
        white-space: nowrap;
    }

    .weekContainer {
        box-sizing: border-box;
        height: 60px;
        margin-bottom: 0;
        margin-top: 8px;
        padding: 0 18px;
        position: relative;
        width: 100%;
    }

    @include breakpoints.mobile-small {
        .daysRow {
            gap: 10px;
            grid-template-columns:
                repeat(5, clamp(60px, calc((100% - 40px) / 4), 72px));
        }
    }

    .arrow {
        position: absolute;
        top: 14px;
        z-index: 1;
    }

    .arrowLeft {
        left: 0;
    }

    .arrowRight {
        right: 0;
    }

    @include breakpoints.desktop {
        float: left;
        margin: 10px 0 0;
        padding: 0 0 0 20px;
        width: 67%;

        .datePickerBand {
            background: transparent;
            display: contents;
            margin: 0;
            padding: 0;
            width: auto;
        }

        .headline {
            font-size: 32px;
            line-height: 41px;
            min-height: 41px;
            width: 340px;
        }

        .daysRow {
            display: flex;
            gap: 16px;
            overflow-x: visible;
            scroll-snap-type: none;
        }

        .daysViewport {
            contain: none;
            overflow-x: visible;
        }

        .dayContainer {
            border-radius: 20px;
            flex: 1 1 0;
            gap: 4px;
            height: 80px;
            max-width: 150px;
            padding: 12px 20px;
        }

        .daySelected {
            border-radius: 20px;
        }

        .dayWords {
            font-size: 16px;
            line-height: 130%;
        }

        .monthYear {
            font-size: 16px;
            line-height: 130%;
        }

        .weekContainer {
            gap: 12px;
            height: 90px;
            margin-bottom: 18px;
            margin-top: 16px;
            padding: 0 16px 0 0;
            width: 100%;
        }

        .arrow {
            position: static;
        }
    }
}

.seeMoreWaitlist {
    float:left;
    width: 100%;
    margin-top: 10px;
}
.seeMore {
    background: #eef5fc;
    border-radius: 20px;
    min-height: 48px;
    font-family: typography.$font-mont;
    font-weight: 600;
    font-style: normal;
    font-size: 16px;
    line-height: 100%;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;
    color: var(--brand-indigo);
    margin: 5px 0px;
    padding: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    text-decoration: none;
    float:left;
    width: 100%;
    cursor: pointer;
    box-sizing: border-box;
    a {
        text-decoration: none;
    }
}

.emptyHeight{
    height:200px
}

.underLine{
    border: 0.5px solid var(--gray-06);
    position: relative;
    margin-top: 10px;
}
